// extracted by mini-css-extract-plugin
module.exports = {"defaultPagination":"styles_defaultPagination__4Kf63"};